import React from 'react';
import { Link } from 'react-router-dom';

function LogoHeader() {
  return (
    <div style={{
      position: 'absolute',
      top: '20px',
      left: '40px',
      zIndex: 1000
    }}>
      <Link to="/" style={{ display: 'flex', alignItems: 'center', textDecoration: 'none' }}>
        <img
          src="/Logo-BamboAct.png" 
          alt="Logo Bambo Eventos"
          style={{ height: '70px', filter: 'brightness(1.2)' }} 
        />
      </Link>
    </div>
  );
}

export default LogoHeader;